// Site scripts, bundled by `npm run build:js` (esbuild) into js/scripts.js
import { initDisclosures, initDropdowns } from "./menus.js";
import { initForm } from "./forms.js";
import { initGalleries } from "./gallery.js";

initDisclosures();
initDropdowns();
initGalleries();
initForm(document.getElementById("quote-form"), { includePostOrigin: true });
initForm(document.getElementById("contact-form"));
